import { useQuery } from 'react-query'
import * as Sentry from '@sentry/react'
import Cookies from 'js-cookie'
import { getUserAndPaymentMethods } from '../api'
import { ERROR_GETTING_USER_PAYMENT_METHOD_INFO } from '../errorConstants'

// CON-9232 Phase 3: read the combined { user, paymentMethods } payload that
// cartOrderAction injects into window.React.userAndPaymentMethods so useQuery
// starts in success state. Sensitive fields (sid, flash_messages,
// forter_payment_token) are stripped server-side before injection. Falls back
// to the existing parallel-fetch path when the payload is missing/invalid.
const initialUserAndPaymentMethods = (() => {
    try {
        return window.React?.userAndPaymentMethods
            ? JSON.parse(window.React.userAndPaymentMethods)
            : undefined
    } catch (e) {
        return undefined
    }
})()

const useFetchUserAndPaymentMethods = () => {
    const { data, error, isLoading, isSuccess, isError } = useQuery(
        ['userAndPaymentMethods'],
        getUserAndPaymentMethods,
        {
            initialData: initialUserAndPaymentMethods,
            onError: (error) => {
                error.name = ERROR_GETTING_USER_PAYMENT_METHOD_INFO
                Sentry.captureException(error, {
                    contexts: {
                        data: {
                            errorMessage:
                                "Error getting the user and/or the user's payment methods",
                        },
                    },
                    user: {
                        id: JSON.stringify(Cookies.get('GCG_CLIENT_USER_ID')),
                    },
                })
            },
            refetchOnWindowFocus: false,
        }
    )

    return { data, error, isLoading, isSuccess, isError }
}

export default useFetchUserAndPaymentMethods
